import { render, staticRenderFns } from "./Etiquetas.vue?vue&type=template&id=271d1fa4&"
import script from "./Etiquetas.vue?vue&type=script&lang=ts&"
export * from "./Etiquetas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports